module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', _vm._g(_vm._b({
    staticClass: "rt-menu",
    class: ['is-' + _vm.menuHeight],
    attrs: {
      "collapse": _vm.collapse,
      "unique-opened": _vm.uniqueOpened,
      "collapse-transition": _vm.collapseTransition,
      "default-active": _vm.defaultActive,
      "default-openeds": _vm.defaultOpeneds,
      "high-index": _vm.activeIndex
    }
  }, 'el-menu', _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d357281a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/menu/rtMenu.vue
// module id = 2221
// module chunks = 137